import { store } from '../stores/mainStore';

export function preload() {
	const m = window.manager;
	if(m.sceneFirstLoaded) 		return; 	// no loading again?
	let scene = this;
	let showSize = false;
	store.phaserLoading = true;
	console.log('phaser loading');

	this.load.once('complete', function () {
		//store.phaserLoading = false;
		if (store.tutorialMode) {
			store.tutorialState = 'avaOpponent';
		}
	});

	this.load.on('progress', v => {
		store.phaserLoadPercentage = Math.floor(v * 100);
	});

	this.load.on('loaderror', function (fileObj) {
		console.log('phaser loadERROR ' + fileObj);
	});

	if(m.sceneFirstLoaded !== true) {
		this.load.audioSprite('sfx', m.assetURL + '/sounds/audio_web.json', [
			m.assetURL + '/sounds/audio_web.ogg',
			m.assetURL + '/sounds/audio_web.mp3',
			m.assetURL + '/sounds/audio_web.m4a'
		]);
	}

	const loadMultiAtlas = (keyName, jsonPath, assetPath) => {
		if(!this.textures.exists(keyName)) {
			console.log("LOADING MULTIATLAS: "+keyName);
			this.load.multiatlas(keyName, jsonPath, assetPath);
		}
	}
	const loadSpriteSheet = (keyName, asset, obj, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadSpriteSheets.push({keyName: keyName, asset: asset, obj: obj});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
						scene.load.spritesheet(keyName, asset, obj);
					});
				} else {
					console.log("LOADING SPRITESHEET: "+keyName);
					scene.load.spritesheet(keyName, asset, obj);
				}
			}
		}
	}
	const loadImage = (keyName, asset, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadImages.push({keyName: keyName, asset: asset});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING IMAGE: '+asset+'\t\t SIZE: '+size);
						scene.load.image(keyName, asset);
					});
				} else {
					console.log("LOADING IMAGE: "+asset);
					scene.load.image(keyName, asset);
				}
			}
		}
	}
	function get_filesize(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
									 //  to get only the header
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				callback(parseInt(xhr.getResponseHeader("Content-Length")));
			}
		};
		xhr.send();
	}
	
	let lang = store.validLanguage;
	const skinPath = m.assetURL + '/skin/';	// skins instead of customAssets or Themes

	loadMultiAtlas('common', m.assetURL + '/sprite_sheets/common-phaser.json', m.assetURL + '/sprite_sheets');
	loadImage('goalArrow', m.assetURL + '/languages/' + lang + '/goal_arrow.png');
	loadImage('bestHand', m.assetURL + '/languages/' + lang + '/bestHand.png');

	loadSpriteSheet('cup_sheet', skinPath + 'cup_sheet.png', {frameWidth: 180, frameHeight: 185});
	loadSpriteSheet('dice3D_sheet', skinPath + 'dice3D_sheet.png', {frameWidth: 128, frameHeight: 128});
	loadMultiAtlas('dice2D_sheet', skinPath + 'dice2D_sheet.json', skinPath);
	loadMultiAtlas('dice2D_sheet_64', skinPath + 'dice2D_sheet_64.json', skinPath);
	loadSpriteSheet('suits', skinPath + 'suits.png', {frameWidth: 54, frameHeight: 57});
	loadImage('gameBkg', skinPath + 'gameBkg.jpg');
	loadImage('watermark', skinPath + 'watermark.png');
	loadImage('playfieldFrame', skinPath + 'playfieldFrame.png');

	loadSpriteSheet('logo_dice_sheet', m.assetURL + '/game/logo_grid_4.png', {frameWidth: 223, frameHeight: 225});
	loadSpriteSheet('goalPanel', m.assetURL + '/sprite_sheets/goal_panel.png?v=1', {
		frameWidth: 306,
		frameHeight: 77,
	});

	loadSpriteSheet('flair', m.assetURL + '/sprite_sheets/dice_select_highlight/' + lang + '.png?v=1', {
		frameWidth: 338,
		frameHeight: 336,
	});
	loadMultiAtlas(
		'floatingStars',
		m.assetURL + '/sprite_sheets/floatingStars.json',
		m.assetURL + '/sprite_sheets'
	);
	loadMultiAtlas('poofNoCloud', m.assetURL + '/sprite_sheets/poofNoCloud.json', m.assetURL + '/sprite_sheets');
	loadMultiAtlas('swirl', m.assetURL + '/sprite_sheets/swirl.json', m.assetURL + '/sprite_sheets');

	loadSpriteSheet('button_help', m.assetURL + '/btn_help.png', {
		frameWidth: 85,
		frameHeight: 81,
	});
	loadSpriteSheet('button_zoom', m.assetURL + '/btn_zoom.png', {
		frameWidth: 82,
		frameHeight: 86,
	});
	/* loadSpriteSheet('zoomer', m.assetURL + '/zoomers.png', {
		frameWidth: 250,
		frameHeight: 250,
	}); */
	loadImage('zoomer', m.assetURL + '/game/zoomer.png');
	loadSpriteSheet('hand', m.assetURL + '/hand_sheet.png', {
		frameWidth: 178,
		frameHeight: 181,
	});
	loadImage('border', m.assetURL + '/game/bumper320thick.jpg'); //left out of sprite sheet.
	loadImage('dimPanel', m.assetURL + '/game/dimPanel.png');
	loadImage('profile_default', m.assetURL + '/profile_default.jpg');
	loadImage('popper_button', m.assetURL + '/game/play_on_no_text.png');
	loadImage('popper_button_grey', m.assetURL + '/game/play_off_no_text.png');
	loadImage('resultPanel', m.assetURL + '/popups/box_results_balance_well.png');
	loadImage('stakePanel', m.assetURL + '/popups/box_stakes_balance_well.png');
	loadImage('settings', m.assetURL + '/buttons/icon_gear.png');
	loadImage('helpBtn', m.assetURL + '/buttons/btn_help.png');
	loadImage('coin', m.assetURL + '/coin_front.png');
	loadImage('multi_0', m.assetURL + '/multiplier/multi_0_single.png');
	loadImage('multi_1', m.assetURL + '/multiplier/multi_1_single.png');
	loadImage('multi_2', m.assetURL + '/multiplier/multi_2_single.png');
	loadImage('multi_3', m.assetURL + '/multiplier/multi_3_single.png');
	loadSpriteSheet('multi_spin', m.assetURL + '/multiplier/sprite_sheet_multiplier.png', {
		frameWidth: 500,
		frameHeight: 530,
	});

	/* loadMultiAtlas(
		'tutorial',
		m.assetURL + '/languages/' + lang + '-tutorial.json?cache=' + Date.now().toString(),
		m.assetURL + '/languages'
	); */

	//not needed for FTUE
	let sideLoadRest = false;
	if(store.tutorialMode || store.ftueMode) {
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0)
			return;	//below files already marked for sideloading.
		sideLoadRest = true;
	}
	
	loadImage('btn_close', m.assetURL + '/buttons/btn_close.png'  , sideLoadRest);
	loadImage('tutorial_box', m.assetURL + '/game/tutorial_boxes.png' , sideLoadRest);

	m.sceneNeedsToReload = false;
	//end discreet loaded images:
}
